import app from 'flarum/forum/app';
import m from 'mithril';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import BottomNav from './components/BottomNav';
import addTagCovers from './tagCovers';
import addHomefeed from './homefeed';
import addPostbit from './postbit';
import addInlineReply from './inlineReply';
import addAnimeAvatars from './animeAvatar';

app.initializers.add('reverserid-theme', () => {
  addAnimeAvatars();
  addTagCovers();
  addHomefeed();
  addPostbit();
  addInlineReply();
  // -------------------------------------------------------------------------
  // Mobile bottom navigation. Mounted once outside the router
  const mountBottomNav = () => {
    if (document.getElementById('rvsr-bottomnav-root')) return;
    const root = document.createElement('div');
    root.id = 'rvsr-bottomnav-root';
    document.body.appendChild(root);
    m.mount(root, BottomNav);
  };
  if (document.body) mountBottomNav();
  else document.addEventListener('DOMContentLoaded', mountBottomNav);

  // -------------------------------------------------------------------------
  // Lightbox: klik gambar di body post (bukan emoji) → buka full-size overlay.
  // Gambar sendiri tampil compact (max-height) via CSS; ini buat lihat penuh.
  // -------------------------------------------------------------------------
  if (!window.__rvsrLightbox) {
    window.__rvsrLightbox = true;
    document.addEventListener('click', (e) => {
      const t = e.target;
      if (!t || !t.closest) return;
      const img = t.closest('.Post-body img');
      if (!img || !img.src || img.classList.contains('emoji') || img.closest('a')) return;
      e.preventDefault();
      const ov = document.createElement('div');
      ov.className = 'RvsrLightbox';
      const full = document.createElement('img');
      full.src = img.src;
      full.alt = '';
      ov.appendChild(full);
      ov.addEventListener('click', () => ov.remove());
      document.addEventListener('keydown', function esc(ev) {
        if (ev.key === 'Escape') {
          ov.remove();
          document.removeEventListener('keydown', esc);
        }
      });
      document.body.appendChild(ov);
    });
  }

  // -------------------------------------------------------------------------
  // Post number BF-style (#1, #2, ...) at the far right of the post bar.
  // -------------------------------------------------------------------------
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const number = this.attrs.post.number();
    if (!number) return;
    items.add(
      'rvsr-addr',
      <a
        className="Rvsr-addr"
        href={app.route.post(this.attrs.post)}
        title={`Post #${number}`}
        onclick={(e) => {
          e.preventDefault();
          m.route.set(app.route.post(this.attrs.post));
        }}
      >
        #{number}
      </a>,
      -5
    );
  });

  // -------------------------------------------------------------------------
  // "Copy" button on every code block in a post body.
  // -------------------------------------------------------------------------
  extend(CommentPost.prototype, ['oncreate', 'onupdate'], function () {
    if (this.element) addCopyButtons(this.element);
  });
});
